package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteSummary
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{id}/complete — driver-initiated end of route (MIL-36). [reason] is
 * required by the backend only when the route still has Pending stops (MIL-81). */
class CompleteRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(id: String, confirmed: Boolean = true, reason: String? = null): RouteSummary =
        repository.completeRoute(id, confirmed, reason)
}
